// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vc-container.custom-calendar{width:100%}.vc-container.custom-calendar .vc-pane-container .vc-pane-layout .vc-pane .vc-weeks .vc-day{margin:5px;min-height:100px}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,8BAAA,UAAA,CAAA,4FAAA,UAAA,CAAA,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
